export const environment = {
  production: "false",
  apiUrl: "https://lboard-tp-api.azurewebsites.net/api",
  mixpanelToken: "19dfd5cb5725e99afa41d70485c98e8b",
  hereMapsApiKey: "1esITJLeGQw8MzZ0s0jrhwGPFrvWoRnZsnH0Ju8ROxo",
  syncfusionLicense: "Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH9eeHVURWhfUE1+XUI=",
  applicationInsightsConnectionString: "InstrumentationKey=bf712f04-776b-40f0-b38b-e6d9bca1d6f0;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=df79bdc6-5d25-4783-8066-a4fe8284a5d1",
  intercomAppId: "iwym1wgm"
};
